import { NavLink } from 'react-router-dom';

import styled from 'styled-components';

export const StyledNavLink = styled(NavLink)`
  padding: var(--space-2) var(--space-3);
  font-size: var(--fs-sm);
  font-weight: var(--fw-bold);
  color: var(--c-text-muted);
  border-radius: var(--radius-md);
  transition:
    color 0.2s ease,
    background-color 0.2s ease;

  &:hover {
    color: var(--c-text);
    background-color: var(--c-surface-2);
  }

  &.active {
    color: var(--c-accent);
  }

  @media (min-width: 786px) {
    font-size: var(--fs-base);
  }
`;
